import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/hcaf-next-site/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/hcaf-next-site/src/app/about/components/AboutStory.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/hcaf-next-site/src/app/about/components/CommunityStats.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/hcaf-next-site/src/app/about/components/ContactSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/hcaf-next-site/src/app/about/components/TeamSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/hcaf-next-site/src/app/about/components/TimelineSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/hcaf-next-site/src/app/about/components/ValuesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/hcaf-next-site/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/hcaf-next-site/src/components/ui/AppImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/hcaf-next-site/src/components/ui/AppLogo.tsx");
